import { connect } from 'react-redux'
import { setErrorMessage, setModal, notify } from 'actions/account'

const mapStateToProps = () => ({})

const withRedux = connect(mapStateToProps, {
  setErrorMessage,
  setModal,
  notify
})

export default withRedux
